var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _g2, _g3, _path12, _path13, _path14, _path15, _g4, _ellipse, _ellipse2, _ellipse3, _rect, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3926_112479)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95215 41.8502C8.37098 40.5793 11.0936 39.1005 12.6061 38.5371L14.9687 42.7157L21.2836 44.1085C20.4971 44.1085 13.8007 47.2256 10.9016 48.7513V44.0605C9.46102 43.0252 7.95215 41.8502 7.95215 41.8502Z",
    fill: "#D74F58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4382 41.8502C44.0194 40.5793 41.2968 39.1005 39.7843 38.5371L37.4217 42.7157L30.639 44.1085C31.4255 44.1085 38.5897 47.2256 41.4888 48.7513V44.0605C42.9294 43.0252 44.4382 41.8502 44.4382 41.8502Z",
    fill: "#D74F58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4768 40.8594L21.2834 44.1094L14.9685 42.7165L18.4768 40.8594Z",
    fill: "#D74F58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6792 40.8594L30.6387 44.1094L37.4214 42.7165L33.6792 40.8594Z",
    fill: "#D74F58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9992 0L33.4936 8.70531H18.5048L25.9992 0Z",
    fill: "url(#paint0_linear_3926_112479)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 49.6777L18.5057 40.9724L33.4944 40.9724L26.0001 49.6777Z",
    fill: "url(#paint1_linear_3926_112479)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3926_112479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0005 2.32227L26.8687 4.94261L29.5087 5.80439L26.8687 6.66617L26.0005 9.28651L25.1322 6.66617L22.4922 5.80439L25.1322 4.94261L26.0005 2.32227Z",
    fill: "#FFE17A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0005 2.39317L26.8475 4.94962L26.8511 4.96031L26.8618 4.96381L29.4369 5.80439L26.8618 6.64497L26.8511 6.64846L26.8475 6.65915L26.0005 9.2156L25.1534 6.65915L25.1498 6.64846L25.1391 6.64497L22.5641 5.80439L25.1391 4.96381L25.1498 4.96031L25.1534 4.94962L26.0005 2.39317Z",
    stroke: "#FAFF00",
    strokeWidth: 0.0446064
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6731 37.2588L36.3303 39.3481L43.8247 26.4642L47.6731 37.2588Z",
    fill: "url(#paint2_linear_3926_112479)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32687 12.4189L15.6697 10.3297L8.17533 23.2135L4.32687 12.4189Z",
    fill: "url(#paint3_linear_3926_112479)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6726 12.419L43.8241 23.2135L36.3298 10.3297L47.6726 12.419Z",
    fill: "url(#paint4_linear_3926_112479)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32767 37.2568L8.17613 26.4622L15.6705 39.3461L4.32767 37.2568Z",
    fill: "url(#paint5_linear_3926_112479)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3006 24.6079C45.3006 35.0586 36.7647 43.532 26.2335 43.532C15.7023 43.532 7.16645 35.0586 7.16645 24.6079C7.16645 14.1572 15.7023 5.68378 26.2335 5.68378C36.7647 5.68378 45.3006 14.1572 45.3006 24.6079Z",
    fill: "url(#paint6_linear_3926_112479)",
    stroke: "url(#paint7_linear_3926_112479)",
    strokeWidth: 0.223032
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3926_112479)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.2338,
    cy: 24.6029,
    rx: 16.8397,
    ry: 16.7142,
    fill: "url(#paint8_linear_3926_112479)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_3926_112479)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.2333,
    cy: 24.6023,
    rx: 14.0331,
    ry: 13.9285,
    fill: "url(#paint9_linear_3926_112479)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3926_112479)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8706 22.0191C17.6457 21.415 18.3212 20.8735 18.8619 21.2244L30.4872 28.7689C31.0461 29.1316 30.7892 29.9993 30.1229 29.9993H21.306C21.0265 29.9993 20.7765 29.8255 20.679 29.5636L17.8706 22.0191Z",
    fill: "url(#paint10_linear_3926_112479)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5973 22.011C34.8245 21.4084 34.1525 20.8641 33.6102 21.2116L21.8192 28.7668C21.2565 29.1274 21.5118 29.9993 22.1802 29.9993H31.1228C31.4013 29.9993 31.6506 29.8268 31.7489 29.5662L34.5973 22.011Z",
    fill: "url(#paint11_linear_3926_112479)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6348 19.4173C25.8795 18.9173 26.5921 18.9173 26.8368 19.4173L31.5937 29.1358C31.8112 29.5803 31.4876 30.099 30.9927 30.099H21.4789C20.984 30.099 20.6603 29.5803 20.8779 29.1358L25.6348 19.4173Z",
    fill: "url(#paint12_linear_3926_112479)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3926_112479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 19,
    width: 12,
    height: 12
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6356 19.4173C25.8802 18.9173 26.5928 18.9173 26.8375 19.4173L31.5944 29.1358C31.812 29.5803 31.4883 30.099 30.9934 30.099H21.4796C20.9847 30.099 20.6611 29.5803 20.8787 29.1358L25.6356 19.4173Z",
    fill: "url(#paint13_linear_3926_112479)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3926_112479)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3926_112479)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.10547,
    cy: 1.65694,
    rx: 6.10547,
    ry: 1.65694,
    transform: "matrix(0.204188 0.978932 -0.979534 0.201279 30.0181 19.6797)",
    fill: "#FFF5D2",
    fillOpacity: 0.8
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.2362,
    cy: 17.3151,
    rx: 1.07308,
    ry: 1.06508,
    fill: "url(#paint14_linear_3926_112479)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.7566,
    cy: 20.4124,
    rx: 0.877976,
    ry: 0.871431,
    fill: "url(#paint15_linear_3926_112479)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.6712,
    cy: 20.4124,
    rx: 0.877976,
    ry: 0.871431,
    fill: "url(#paint16_linear_3926_112479)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.7964,
    y: 30.9355,
    width: 10.6728,
    height: 1.44453,
    rx: 0.722267,
    fill: "url(#paint17_linear_3926_112479)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7488 12.5371L19.0961 13.5852L20.1521 13.93L19.0961 14.2747L18.7488 15.3228L18.4015 14.2747L17.3455 13.93L18.4015 13.5852L18.7488 12.5371Z",
    fill: "#FFE17A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5398 7.88867L15.3501 10.3343L17.8142 11.1387L15.3501 11.943L14.5398 14.3886L13.7294 11.943L11.2654 11.1387L13.7294 10.3343L14.5398 7.88867Z",
    fill: "#FFE17A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3926_112479",
    x: 21.8231,
    y: 1.65317,
    width: 8.35479,
    height: 8.30304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.334548,
    result: "effect1_foregroundBlur_3926_112479"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3926_112479",
    x: 9.39404,
    y: 7.44261,
    width: 33.6794,
    height: 33.8738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.446064
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.223032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.616667 0 0 0 0 0.407 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3926_112479"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_3926_112479",
    x: 12.2002,
    y: 10.2278,
    width: 28.0662,
    height: 28.7496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.446064
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.446064
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7 0 0 0 0 0.465967 0 0 0 0 0.0116667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3926_112479"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.446064
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.223032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.72 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3926_112479",
    result: "effect2_innerShadow_3926_112479"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3926_112479",
    x: 16.4326,
    y: 16.25,
    width: 19.5625,
    height: 17.023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.446064
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.223032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.358333 0 0 0 0 0.1935 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3926_112479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3926_112479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3926_112479",
    x: 26.2568,
    y: 18.6657,
    width: 6.76989,
    height: 14.649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.669096,
    result: "effect1_foregroundBlur_3926_112479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3926_112479",
    x1: 22.8839,
    y1: 3.48212,
    x2: 29.1146,
    y2: 3.48212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3926_112479",
    x1: 29.1154,
    y1: 46.1956,
    x2: 22.8847,
    y2: 46.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3926_112479",
    x1: 46.1925,
    y1: 32.8399,
    x2: 43.112,
    y2: 38.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3926_112479",
    x1: 5.80746,
    y1: 16.8378,
    x2: 8.88797,
    y2: 11.4622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3926_112479",
    x1: 43.0766,
    y1: 11.4822,
    x2: 46.1572,
    y2: 16.8578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3926_112479",
    x1: 8.9236,
    y1: 38.1936,
    x2: 5.84309,
    y2: 32.8179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3926_112479",
    x1: 13.9396,
    y1: 10.4532,
    x2: 39.299,
    y2: 38.9512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237301,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3926_112479",
    x1: 26.2335,
    y1: 5.57227,
    x2: 26.2335,
    y2: 43.6435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3926_112479",
    x1: 15.4751,
    y1: 11.8351,
    x2: 36.8019,
    y2: 37.7596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D58500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3926_112479",
    x1: 16.9467,
    y1: 13.1318,
    x2: 28.3604,
    y2: 38.5949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#B45F1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3926_112479",
    x1: 18.0878,
    y1: 22.931,
    x2: 23.7538,
    y2: 27.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3926_112479",
    x1: 33.7932,
    y1: 21.7318,
    x2: 30.3806,
    y2: 27.9206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3926_112479",
    x1: 23.2536,
    y1: 24.3201,
    x2: 29.3031,
    y2: 24.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FCE77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3926_112479",
    x1: 23.2544,
    y1: 24.3201,
    x2: 29.3039,
    y2: 24.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FCE77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3926_112479",
    x1: 26.2362,
    y1: 16.25,
    x2: 26.2362,
    y2: 18.3802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3926_112479",
    x1: 17.7566,
    y1: 19.541,
    x2: 17.7566,
    y2: 21.2839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3926_112479",
    x1: 34.6712,
    y1: 19.541,
    x2: 34.6712,
    y2: 21.2839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3926_112479",
    x1: 20.9177,
    y1: 31.6578,
    x2: 31.5905,
    y2: 31.6578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE07C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3926_112479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.34c12756e9727dde05dad8bb992dc84f.svg";
export { ForwardRef as ReactComponent };